import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputDialogOptions } from './input-dialog';


@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    AllowBlankResponse?: boolean;
    InputLabel?: string;
    InputText?: string;
    MaxLength!: number | null;

    constructor(
        private dialogRef: MatDialogRef<InputDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: InputDialogOptions,
    ) {
        const self = this;
        self.TitleText = opts.TitleText || 'Information Requested...';
        self.MessageText = opts.MessageText || '';
        self.OKText = opts.OKText || 'Done';
        self.CancelText = opts.CancelText || 'Cancel';
        self.AllowBlankResponse = opts.AllowBlankResponse || false;
        self.InputLabel = opts.InputLabel || '';
        self.InputText = opts.InputText || '';
        self.MaxLength = opts.MaxLength || null;
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(this.InputText);
    }
}
